/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-01 13:51:39
 * @modify date 2022-12-23 13:12:07
 * @desc this is a config file that is used with the theme provider from material-ui, this allows for customisation of the theme aswell as enabling certain functions throughout the application
 */

import React from 'react';

// Material-ui
import { createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useTheme = () => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    return React.useMemo(
        () =>
            createTheme({
                palette: {
                    mode: prefersDarkMode ? 'dark' : 'light',
                    primary: {
                        main: '#7bad70'
                    }
                }
            }),
        [prefersDarkMode],
    )
}

export { useTheme }